var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-day",class:{
    'calendar-day--not-current': !_vm.day.isCurrentMonth,
    'calendar-day--today': _vm.isSelected
  }},[_c('div',{on:{"click":function($event){return _vm.selectDay(_vm.day.date)}}},[_c('div',{staticClass:"week-label mt-2"},[_vm._v(" "+_vm._s(_vm.labelMonth)+" ")]),_c('div',{staticClass:"week-label label-day"},[_vm._v(" "+_vm._s(_vm.labelDay)+" ")]),(_vm.registration && _vm.registration.length)?_c('div',{class:{
        'calendar-registration-count': _vm.isSelected,
        'calendar-registration-count--not-selected': !_vm.isSelected
      }},[_vm._v(" "+_vm._s(_vm.registration.length)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }